exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".legend-custom[_v-8c6768d4]{padding-left:0}.custom-checkbox>[type=checkbox]:checked+label[_v-8c6768d4]:before,.custom-checkbox>[type=checkbox]:checked:focus+label[_v-8c6768d4]:before,.custom-checkbox>[type=checkbox]:disabled:checked+label[_v-8c6768d4]:before,.custom-checkbox>[type=checkbox]:disabled:checked+label[_v-8c6768d4]:hover:before,.custom-checkbox>[type=checkbox]:disabled:not(:checked)+label[_v-8c6768d4]:before,.custom-checkbox>[type=checkbox]:disabled:not(:checked)+label[_v-8c6768d4]:hover:before,.custom-checkbox>[type=checkbox]:not(:checked)+label[_v-8c6768d4]:before,.custom-checkbox>[type=checkbox]:not(:checked):focus+label[_v-8c6768d4]:before,.custom-checkbox>label[_v-8c6768d4]:hover:before{border:.5px solid #979797!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-8c6768d4&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Admin-form.vue
// module id = 449
// module chunks = 0